import React, { memo } from 'react';
import { CircularProgress } from '@mui/material';

import { useStyles } from './styles';

export interface IFullscreenLoader {
  transparent?: boolean;
  backgroundStyleClass?: string;
  spinnerStyleClass?: string;
  text?: string;
  testId?: string;
}

const FullscreenLoader = ({
  transparent = false,
  backgroundStyleClass = '',
  spinnerStyleClass = '',
  text,
  testId,
}: IFullscreenLoader) => {
  const classes = useStyles();
  return (
    <>
      <div
        className={`${classes.background} ${transparent ? classes.transparentBackground : ''} ${backgroundStyleClass}`}
        data-testid={testId}
      />
      <CircularProgress className={`${classes.spinner} ${spinnerStyleClass}`} />
      {text && <div className={classes.loadingText}>{text}</div>}
    </>
  );
};

export default memo(FullscreenLoader);
